const setError = ():boolean => {return true }
const clearError = ():boolean => { return false }

export { setError, clearError }